import { render, staticRenderFns } from "./BTabDetailProyek.vue?vue&type=template&id=7011b6e9&scoped=true"
import script from "./BTabDetailProyek.vue?vue&type=script&lang=js"
export * from "./BTabDetailProyek.vue?vue&type=script&lang=js"
import style0 from "./BTabDetailProyek.vue?vue&type=style&index=0&id=7011b6e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011b6e9",
  null
  
)

export default component.exports